import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SentryService } from 'src/app/_provider/sentry/sentry.service';

@Component({
  selector: 'sentry-page',
  templateUrl: './sentry.page.html',
  styleUrls: ['./sentry.page.scss', '../setting-main.scss'],
})
export class SentryPage implements OnInit {

  public isModal: boolean = false
  public onlyText: boolean = false

  constructor(
    public sentrySrv: SentryService,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }


}
